import { render, staticRenderFns } from "./ModelConfig.vue?vue&type=template&id=264809f8&scoped=true"
import script from "./ModelConfig.vue?vue&type=script&lang=js"
export * from "./ModelConfig.vue?vue&type=script&lang=js"
import style0 from "./ModelConfig.vue?vue&type=style&index=0&id=264809f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264809f8",
  null
  
)

export default component.exports